module.exports = __webpack_public_path__ + "assets/img/8.f7393124.png";